import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Table, Tag } from "antd";
import { del, get, post } from "../../api/axios";
import { Pagination, message } from "antd";
import SearchBar from "../../utils/SearchBar";

const UsersRates = () => {
  // ant-table-content
  const columns = [
    //1
    {
      title: (
        <>
          رقم الحجز
          <br />
          كود الوحدة
          <br />
          تاريخ الانشاء
        </>
      ),

      width: "100px",
      render: ({ reservation_number, reservation_date, property_code }) => (
        <>
          {reservation_number || "-"}
          <br />
          {property_code || "-"}
          <br />
          {reservation_date || "-"}
        </>
      ),
    },
    //2
    {
      title: (
        <>
          تاريخ التقييم
          <br />
          رقم الضيف
          <br />
          عرض التعليق
        </>
      ),

      width: "100px",
      render: ({ user, rate_date, user_comment }) => (
        <>
          {rate_date || "-"}
          <br />
          {user ? `G${user?.id}` : "-"}
          <br />
          {user_comment || "-"}
        </>
      ),
    },

    //3
    {
      title: (
        <>
          النظافة
          <br />
          الحالة
          <br />
          الخدمة
        </>
      ),
      width: "100px",
      render: ({
        clean_text,
        clean_number,
        new_number,
        new_text,
        service_number,
        service_text,
      }) => (
        <>
          <span>
            {clean_number} ({clean_text})
          </span>
          <br />
          <span>
            {new_number} ({new_text})
          </span>
          <br />
          <span>
            {service_number} ({service_text})
          </span>
        </>
      ),
    },

    //4
    {
      title: (
        <>
          الجودة والسعر
          <br />
          دقة الوصف
        </>
      ),

      width: "100px",
      render: ({
        matching_number,
        matching_text,
        pricing_number,
        pricing_text,
      }) => (
        <>
          <span>
            {pricing_number} ({pricing_text})
          </span>
          <br />
          <span>
            {matching_number} ({matching_text})
          </span>
        </>
      ),
    },

    //5
    {
      title: " التقييم العام  ",
      width: "100px",

      render: ({ total_rate_number, total_rate_text }) => (
        <span>
          {total_rate_number} <br /> ({total_rate_text})
        </span>
      ),
    },

    //6
    // {
    //   title: "ادارة التقييم",
    //   width: "100px",

    //   render: ({ total_rate_number, total_rate_text }) => <>{"-"}</>,
    // },

    //7
    // {
    //   title: "حالة التقييم",
    //   width: "100px",

    //   render: ({ total_rate_number, total_rate_text }) => <>{"-"}</>,
    // },

    //8
    {
      title: (
        <>
          تاريخ الرد
          <br />
          رقم المضيف
          <br />
          عرض الرد
        </>
      ),

      width: "100px",
      render: ({ owner_phone, reply_date, reply_owner_comment }) => (
        <>
          {reply_date || "-"}
          <br />
          {owner_phone || "-"}
          <br />
          {reply_owner_comment || "-"}
        </>
      ),
    },

    {
      title: "  حالة التقييم ",
      width: "100px",

      render: ({ status }) => (
        <>
          <Tag color={`${status == "محذوف" ? "error" : "success"}`}>
            {status}
          </Tag>
        </>
      ),
    },
    // {
    //   title: "ادارة التقييم",
    //   width: "100px",

    //   render: ({ id, status }) => (
    //     <Popconfirm
    //       disabled={status == "محذوف" ? true : false}
    //       title="حذف العنصر"
    //       description="هل أنت متأكد من حذف هذه العنصر؟"
    //       onConfirm={() => confirm(id)}
    //       onCancel={cancel}
    //       okText="نعم"
    //       cancelText="لا"
    //     >
    //       <Button danger disabled={status == "محذوف" ? true : false}>
    //         حذف
    //       </Button>
    //       {/**  اضافة زر اسمو نشر وبيتغير حسب يا نشر يا اخفاء  وبس اكبس بتطلع بوب اب هل ترغب في نشر التقييم */}
    //       {/*  نفس الشي الاخفاء  زر واحد وبتتبدل الحالة */}
    //     </Popconfirm>
    //   ),
    // },
    {
      title: "ادارة التقييم",
      width: "160px",
      render: ({ id, status }) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "center",
          }}
        >
          {/* زر الحذف يبقى كما هو */}
          <Popconfirm
            disabled={status === "محذوف"}
            title="حذف العنصر"
            description="هل أنت متأكد من حذف هذا العنصر؟"
            onConfirm={() => confirm(id)}
            onCancel={cancel}
            okText="نعم"
            cancelText="لا"
          >
            <Button danger disabled={status === "محذوف"}>
              حذف
            </Button>
          </Popconfirm>

          {/* زر نشر / اخفاء حسب الحالة */}
          <Popconfirm
            title="هل أنت متأكد من قبول التقييم؟"
            onConfirm={() => handleChangeRateStatus(id, 2)}
            okText="تأكيد"
            cancelText="إلغاء"
          >
            <Button
              type="primary"
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                color: "#fff",
              }}
              loading={changingStatusId === id}
            >
              قبول
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];
  const handleDelet = (id) => {
    del(`delete-user-rate/${id}`);

    const newData = [];
    data.map((item) => {
      if (item.id == id) {
        newData.push({ ...item, status: "محذوف" });
      } else {
        newData.push(item);
      }
    });
    setdata(newData);
  };

  // أضف state للتحكم بالloading لكل صف
  const [changingStatusId, setChangingStatusId] = useState(null);

  // دالة لتغيير حالة التقييم
  const handleChangeRateStatus = (rateId, newStatus) => {
    setChangingStatusId(rateId);

    post(`change-rate-status/${rateId}`, { status: newStatus })
      .then(() => {
        message.success("تم قبول التقييم بنجاح");

        // 🔥 نفس فكرة الحذف → احذف السطر من الجدول
        setdata((prev) => prev.filter((item) => item.id !== rateId));
      })
      .catch(() => {
        message.error("حدث خطأ أثناء تعديل الحالة");
      })
      .finally(() => setChangingStatusId(null));
  };

  const confirm = (id) => {
    handleDelet(id);
    message.success("تم الامر بنجاح");
  };
  const cancel = (e) => {
    //console.log(e);
    message.error("تم الغاء الامر");
  };
  const [dataFirst, setdataFirst] = useState([]);
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get(`get-users-rates?search=${searchQuery}`).then((res) => {
      setdataFirst(res?.data?.data);
      setTotal(res?.data?.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);

  useEffect(() => {
    //console.log("dataFirst", dataFirst);
    const newarr = [];
    dataFirst?.map((item) => {
      const newObj = {};

      // item
      newObj.id = item.id;
      newObj.property_code = item.property_code;

      newObj.user_comment = item.user_comment;
      newObj.rate_date = item.rate_date;
      newObj.reservation_number = item.reservation_number;
      newObj.reservation_date = item.reservation_date;

      // item
      newObj.clean_number = item.clean.number;
      newObj.clean_text = item.clean.text;
      // item
      newObj.new_number = item.new.number;
      newObj.new_text = item.new.text;
      // item
      newObj.service_number = item.service.number;
      newObj.service_text = item.service.text;
      // item
      newObj.matching_number = item.matching.number;
      newObj.matching_text = item.matching.text;
      // item
      newObj.pricing_number = item.pricing.number;
      newObj.pricing_text = item.pricing.text;
      // item
      newObj.total_rate_number = item.total_rate.number;
      newObj.total_rate_text = item.total_rate.text;

      // item
      newObj.user_name = item.user.name;
      newObj.user_phone = item.user.phone;
      newObj.user = item.user;

      // item
      newObj.user_comment = item.user_comment;

      newObj.owner_phone = item.owner_phone;

      // item
      newObj.reply_date = item.reply ? item.reply.date : "";
      newObj.reply_owner_name = item.reply ? item.reply.owner.name : "";
      newObj.reply_owner_phone = item.reply ? item.reply.owner.phone : "";

      newObj.reply_owner_comment = item.reply ? item.reply.owner_comment : "";

      newObj.status = item.status;
      newObj.isPublished = false;
      newarr.push(newObj);
    });
    setdata(newarr);
  }, [dataFirst]);

  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`get-users-rates?page=${pageNumber}&search=${searchQuery}`).then((res) => {
      setdataFirst(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                x: 1650,
                y: "65vh",
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersRates;
